const API_DATA_TYPES = {
  'id': 'UUID',
  'email': 'String',
  'name': 'String',
  'lockedAt': 'Time',
  'lastSignInAt': 'Time',
  'credentials': 'UserCredentials',
  'roles': '[Role!]',
  'contact': 'ContactInput',
  'createdAt': 'Time',
  'updatedAt': 'Time',
  'deletedAt': 'Time',
  'companyName': 'String',
  'vatId': 'String',
  'contactPerson': 'String',
  'phone': 'String',
  'address': 'String',
  'postalCode': 'String',
  'city': 'String',
  'country': 'String',
  'enabled': 'Boolean',
  'expires': 'Time',
  'activates': 'Time',
  'token': 'String',
  'user': 'User',
  'type': 'ExternalSourceType',
  'label': 'String',
  'identity': 'UserCredentialsType',
  'meta': 'UserCredentialsTypeMeta',
  'profileUrl': 'String',
  'avatarUrl': 'String',
  'isPublished': 'Boolean',
  'pageUrl': 'String',
  'viewUrl': 'String',
  'editUrl': 'String',
  'categories': '[ShopamineCategory]',
  'url': 'String',
  'description': 'String',
  'vendor': 'String',
  'price': 'Float',
  'tags': '[String!]',
  'media': '[Media!]',
  'events': '[MediaPlanEvent]',
  'owner': 'User',
  'discount': 'Float',
  'discountValidity': 'Time',
  'content': 'String',
  'ref': 'UUID',
  'paymentMethod': 'String',
  'duration': 'Int',
  'currency': 'String',
  'amount': 'Float',
  'settledAt': 'Time',
  'confirmedAt': 'Time',
  'rejectedAt': 'Time',
  'mimetype': 'String',
  'filesize': 'Int',
  'mutation': 'String',
  'refType': 'MediaRefType',
  'refOrder': 'Int',
  'body': 'String! ',
  'subject': 'String! ',
  'from': 'String',
  'to': '[String!]',
  'cc': '[String!]',
  'bcc': '[String!]',
  'text': 'String',
  'html': 'String',
  'status': 'MediaPlanEventStatus',
  'startsAt': 'Time',
  'expiresAt': 'Time',
  'method': 'MediaPlanEventMethod',
  'advertisable': 'UUID',
  'payload': 'MediaPlanEventPayload',
  'link': 'String',
  'scheduledAt': 'Time',
  'message': 'String',
  'actions': '[MediaPlanEventFacebookPostActionInput!]',
  'campaign': 'UUID',
  'postalcode': 'String',
  'title': 'String',
  'password': 'String',
  'culture': 'String',
  'remoteUrl': 'String',
  'publishAt': 'Time',
  'removeAt': 'Time',
  'sqwizArticle': 'MediaPlanEventSqwizArticleInput',
  'sqwizProduct': 'MediaPlanEventSqwizProductInput',
  'facebookPost': 'MediaPlanEventFacebookPostInput',
  'shopamineProduct': 'MediaPlanEventShopamineProductInput',
  'informacijaProduct': 'MediaPlanEventInformacijaProductInput',
  'informacijaPost': 'MediaPlanEventInformacijaPostInput',
  'shopaminePost': 'MediaPlanEventShopaminePostInput',
  'twitterTweet': 'MediaPlanEventTwitterTweetInput',
  'pinterestPin': 'MediaPlanEventPinterestPinInput',
  'wordpressPost': 'MediaPlanEventWordpressPostInput',
  'woocommerceProduct': 'MediaPlanEventWoocommerceProductInput',
  'forceAutoTransformation': 'Boolean',
  'post': 'AdvertisablePostInput',
  'product': 'AdvertisableProductInput',
  'credentialsId': 'UUID',
  'visible': 'Boolean',
  'role': 'UUID',
  'async': 'Boolean',
  'settings': 'UserSettingsInput'
}

export default {
  /**
   * Creates gql mutations head strings - param definitions & param calls
   * @param {Object} fields Fields to be included in this mutation
   * @param {Object} forcedNames Forced type definitions to overwrite defaults
   * @returns {Object}
   */
  makeApolloHeadString (fields = {}, forcedNames = {}) {
    let head = ``
    let params = ``
    for (let field of Object.keys(fields)) {
      if (fields[field] !== undefined) {
        let insert = ''

        // Overwrite above defined atribute types...
        if (forcedNames && forcedNames[field]) {
          insert = forcedNames[field]
        } else {
          insert = API_DATA_TYPES[field]
        }
        head = `${head} $${field}: ${insert}!,`
        params = `${params} ${field}: $${field},`
      }
    }

    head = head.substring(1, head.length - 1)
    params = params.substring(1, params.length - 1)
    return {head, params}
  },

  /**
   * Puts mutation parts together into one string
   * @param {Object} gqlBase mutation parts
   * @returns {String}
   */
  setupGqlString (gqlBase = {}) {
    let mutationString = `
      ${gqlBase.type} (${gqlBase.head}){
        ${gqlBase.name}(${gqlBase.params}) ${gqlBase.fields ? '{' : ''}
          ${gqlBase.fields}
        ${gqlBase.fields ? '}' : ''}
      }`

    return mutationString
  }
}



// WEBPACK FOOTER //
// ./src/assets/modules/apollo/apolloSetup.js